<app-performance-tab
    [storageKey]="storageKey"
    [loadStats]="loadStats"
    [defaultPastDays]="null">
    <ng-template let-stats let-sidenav="sidenav">
        @if (stats.meta.results) {
            <app-policy-type-stats [data]="stats.data"></app-policy-type-stats>
        } @else if (stats.meta.hasObjectives) {
            <app-empty-state
                illustration="search"
                title="No Statistics Yet"
                message="No safety objectives were active in the selected date range and filters.">
                <a
                    class="btn-secondary"
                    (click)="sidenav.open(); $event.stopPropagation()">
                    Edit Filters
                </a>
            </app-empty-state>
        } @else {
            <app-empty-state
                illustration="not-started"
                title="No Safety Objectives Yet"
                message="Safety objectives set what you are aiming for and let you measure it. Create your first one to start tracking performance here.">
                <a class="btn-secondary" routerLink="/policies/objectives">
                    Create Objective
                </a>
            </app-empty-state>
        }
    </ng-template>
</app-performance-tab>
